// can be further refactored with a good zustand context
import React, { useState } from "react";
import { Box, Tabs, Tab, Container } from "@mui/material";

import "./AdminPage.css";

// Import components
import BookingsTableView from "../../components/admin/TableView/BookingsTableView";
import { CalendarViewMonth, TableRows } from "@mui/icons-material";
import CalendarView from "components/admin/CalendarView/CalendarView";

const AdminCalendarPage = () => {
  // Tab state
  const [activeTab, setActiveTab] = useState(0);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className="admin-page">
      <div className="admin-hero">
        <h1>Administration</h1>
        <p>Gérez les disponibilités et les réservations</p>
      </div>

      <Container
        maxWidth="lg"
        sx={{
          mb: { xs: 4, md: 8 },
          px: { xs: 1, sm: 2, md: 3 },
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="admin tabs"
            variant="fullWidth"
            sx={{
              "& .MuiTab-root": {
                fontWeight: "bold",
                fontSize: { xs: "0.875rem", sm: "1rem" },
                color: "#676767",
                "&.Mui-selected": { color: "#c84653" },
              },
              "& .MuiTabs-indicator": { backgroundColor: "#c84653" },
            }}
          >
            <Tab
              label="Vue Calendrier"
              id="tab-0"
              aria-controls="tabpanel-0"
              icon={<CalendarViewMonth />}
              iconPosition="start"
            />
            <Tab
              label="Vue Tableau"
              id="tab-1"
              aria-controls="tabpanel-1"
              icon={<TableRows />}
              iconPosition="start"
            />
          </Tabs>
        </Box>

        {/* Calendar View */}
        {activeTab === 0 && <CalendarView />}

        {/* Table View */}
        {activeTab === 1 && <BookingsTableView />}
      </Container>
    </div>
  );
};

export default AdminCalendarPage;
